import { useSelector } from 'react-redux';
import { emailDomain } from 'constants/generalConstants';
import AloftLogo from 'assets/images/aloft_logo_white.png';
import AirControlLogo from 'assets/images/air_control_white.png';
import { Typography, Button, Box } from '@mui/material';
import { $black, $primary, $white } from 'constants/styles/_colors';
import { useNavigate } from 'react-router-dom';
import { userAccountsSelector } from 'reducers/userAuthSlice';
import LanguageSwitcherWrap from 'components/elements/LanguageSwitcherWrap';
import { useTranslation } from 'react-i18next';
const styles = {
	main: {
		height: '100%',
		width: '100%',
		backgroundColor: $black,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center'
	},
	authCopy: {
		lineHeight: '1.5em',
		fontSize: '18px',
		fontWeight: 'bold',
		marginTop: '30px',
		textAlign: 'center',
		marginBottom: '50px'
	},
	aloftLogo: {
		maxWidth: '300px',
		marginBottom: '50px'
	},
	airControlLogo: {
		maxWidth: '300px',
		marginBottom: '100px'
	},
	button: {
		height: '50px',
		width: '350px'
	},
	linkStyle: {
		textDecoration: 'underline',
		color: $primary
	}
};

const NoAccounts = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const userAccounts = useSelector(userAccountsSelector);
	const multiAccounts = userAccounts?.length > 1;

	return (
		<LanguageSwitcherWrap>
			<Box sx={styles.main}>
				<Box component={'img'} src={AloftLogo} alt='' sx={styles.aloftLogo} />
				<Box component={'img'} src={AirControlLogo} alt='' sx={styles.airControlLogo} />
				<Typography sx={styles.authCopy} style={{ color: $white }}>
					{t("You don't have an active enterprise subscription, please contact")}{' '}
					<Box component={'a'} href={`mailto: sales@${emailDomain}`} sx={styles.linkStyle}>
						sales@aloft.ai
					</Box>{' '}
					{t('for assistance')}.
				</Typography>
				{multiAccounts ? (
					<Button
						onClick={() => navigate('/account-picker')}
						sx={styles.button}
						variant='contained'
					>
						{t('Switch Account')}
					</Button>
				) : (
					<Button onClick={() => navigate('/logout')} sx={styles.button} variant='contained'>
						{t('Logout')}
					</Button>
				)}
			</Box>
		</LanguageSwitcherWrap>
	);
};

export default NoAccounts;
